import { css } from '@linaria/core';

export const defaultBackdropStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--cxy-z-index-dialog);

  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);

  transition: opacity 250ms ease-in-out;
  opacity: 0;
  &[data-enter] {
    opacity: 1;
  }
`;

export const defaultDialogStyles = css`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: auto;

  max-width: calc(100% - 20px);
  min-width: 300px;
  max-height: calc(100% - 20px);
  min-height: 200px;

  transition:
    opacity 250ms ease-in-out,
    transform 250ms ease-in-out;
  opacity: 0;
  &[data-enter] {
    opacity: 1;
  }

  background: transparent;
  border-radius: 3px;
`;
